module.exports = __webpack_public_path__ + "static/media/tool_decorative_line.fb4f5952.png";